export enum PAGINATION_TYPE {
  TEXT,
  ARROW,
}

export enum PAGINATION_DIRECTION {
  PREV = 'prev',
  NEXT = 'next',
}
